import { render } from "./AIProcessModal.vue?vue&type=template&id=09c382c3&scoped=true&ts=true"
import script from "./AIProcessModal.vue?vue&type=script&lang=ts"
export * from "./AIProcessModal.vue?vue&type=script&lang=ts"

import "./AIProcessModal.vue?vue&type=style&index=0&id=09c382c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c382c3"]])

export default __exports__